import { defineStore } from 'pinia';
import { LxViewStore } from '@dativa-lv/lx-ui';

export default defineStore('viewStore', LxViewStore);
